import { AtvIcon } from './AtvIcon';

/**
 * author: Google
 * id 0086E21E-2ABC-4983-8BA7-C9C31B55D6B9
 * name atv
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/atv.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const QuadIcon = AtvIcon;
export default QuadIcon